import { useGet } from './useHttpHooks';
import { RelatedQuestionsAndArticles } from '../types';
import toQuery from '../lib/toQuery';

type GetRelatedQuestionsAndArticlesQuery = {
    qnaEntityId: number;
    tags: string[];
};

const useGetRelatedQuestionsAndArticles = (
    request: GetRelatedQuestionsAndArticlesQuery
) =>
    useGet<RelatedQuestionsAndArticles>(
        `/api/help-page/related-questions-and-articles?${toQuery(request)}`,
        {
            errorMessage: 'GET /api/help-page/related-questions-and-articles'
        }
    );

export default useGetRelatedQuestionsAndArticles;
